import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const companyUsersGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.userInfo?.isAdmin) {
    return true;
  }

  const companyId = route.parent?.params['companyId'] ?? route.params['companyId'];
  if (companyId) {
    router.navigate(['/company', companyId]);
  } else {
    router.navigate(['/company']);
  }
  return false;
};

